import styled from "styled-components";

export const NavBarContainer = styled.div`
  width: 15%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 10%;
  background-color: rgb(52, 58, 64);
  background-color: var(--backgroundPrimary);
  color: #fff;
  @media (max-width: 768px) {
    width: 100vw;
    height: 100vh;
    visibility: ${(props) => (props.showNavBar ? "visible" : "hidden")};
    z-index: 300;
  }
`;

export const SubNavContainer = styled.div`
  height: 100%;
  @media (max-width: 768px) {
    border-top: 1px solid #fff;
  }
`;
